(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('TargetInfoClientsController', TargetInfoClientsController);

    TargetInfoClientsController.$inject = ['$uibModalInstance', 'clients'];

    function TargetInfoClientsController($uibModalInstance, clients) {

        console.log(clients);
        var vm = this;

        vm.clients          = clients;
        vm.ok               = ok;
        vm.cancel           = cancel;

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }

})();